import React, { useMemo, useState } from 'react';
import {
    faFileCirclePlus,
    faGlobe,
    faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tabs } from 'antd';
import AddFile from './addFile';
import AddInternetRepo from './addInternetRepo';
import { RepoType } from '@quyva/common';

const AddContentToRepo = ({
    repo,
    isAdmin,
    getAllReposData,
    getRepoFilesData,
    socket,
    fetchedUrlList,
    setViewNotifications,
    closeSidebar,
    onClose,
    onUrlsAdded,
}) => {
    const showUrlTab = repo?.storage_type !== RepoType.CLOUD;

    const initialMode = useMemo(() => {
        if (repo?.storage_type === RepoType.INTERNET && showUrlTab) {
            return 'url';
        }

        return 'file';
    }, [repo?.storage_type, showUrlTab]);

    const [selectedMode, setSelectedMode] = useState(initialMode);

    const modeConfig = {
        file: {
            icon: faFileCirclePlus,
            label: 'Files',
            helperText: 'Upload PDF, DOCX, TXT, Markdown, and image files',
        },
        url: {
            icon: faGlobe,
            label: 'URLs',
            helperText: 'Add website URLs to this repository',
        },
    };

    if (!repo) {
        return null;
    }

    const tabItems = [
        {
            key: 'file',
            label: (
                <span>
                    <FontAwesomeIcon icon={modeConfig.file.icon} className='mr-2' />
                    {modeConfig.file.label}
                </span>
            ),
            children: (
                <div className='h-full min-h-0 flex flex-col overflow-hidden'>
                    <AddFile
                        embeddedMode={true}
                        setAddFileMode={onClose}
                        foldername={repo.name}
                        repoid={repo.repoid}
                        getRepoFilesData={getRepoFilesData}
                        socket={socket}
                        setViewNotifications={setViewNotifications}
                        closeSidebar={closeSidebar}
                        mail={repo.email}
                    />
                </div>
            ),
        },
    ];

    if (showUrlTab) {
        tabItems.push({
            key: 'url',
            label: (
                <span>
                    <FontAwesomeIcon icon={modeConfig.url.icon} className='mr-2' />
                    {modeConfig.url.label}
                </span>
            ),
            children: (
                <div className='h-full min-h-0 flex flex-col overflow-hidden'>
                    <AddInternetRepo
                        isAdmin={isAdmin}
                        reponame={repo.name}
                        setAddNewMode={onClose}
                        getAllReposData={getAllReposData}
                        socket={socket}
                        fetchedUrlList={fetchedUrlList}
                        user={JSON.parse(localStorage.getItem('current'))}
                        existingRepo={true}
                        onUrlsAdded={onUrlsAdded}
                    />
                </div>
            ),
        });
    }

    return (
        <div className='w-[78vw] max-w-[1080px] h-[78vh] max-h-[78vh] flex flex-col bg-backgrounds-slate rounded-xl overflow-hidden'>
            <div className='px-4 pb-0.5 border-b border-backgrounds-primary200 bg-backgrounds-slate'>
                <div className='text-base font-semibold text-texts-primary mb-0.5'>
                    Add content to `{repo.name}`
                </div>
                <div className='flex items-center text-sm text-texts-secondary300'>
                    <FontAwesomeIcon icon={faCircleInfo} className='mr-2' />
                    {modeConfig[selectedMode].helperText}
                </div>
            </div>

            <div className='flex-1 min-h-0 px-2.5 pt-0 pb-2.5'>
                <Tabs
                    activeKey={selectedMode}
                    onChange={setSelectedMode}
                    className='h-full add-content-tabs [&_.ant-tabs-nav]:mb-2 [&_.ant-tabs-nav]:mt-0 [&_.ant-tabs-content-holder]:h-full [&_.ant-tabs-content-holder]:min-h-0 [&_.ant-tabs-content]:h-full [&_.ant-tabs-content]:min-h-0 [&_.ant-tabs-tabpane]:h-full [&_.ant-tabs-tabpane]:min-h-0'
                    items={tabItems}
                />
            </div>
        </div>
    );
};

export default AddContentToRepo;
